import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers } from 'recompose'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as ApiKeyActions from 'modules/apiKey/actions'

import InstallChoice from './component'

const mapStateToProps = (state) => ({
  embedSnippet: OrgSelectors.getEmbedSnippet(state) || '',
  installOption: OrgSelectors.getInstallOption(state)
})

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators({
    setInstallOption: OrgActions.setInstallOption,
    getApiKeyForOrg: ApiKeyActions.getApiKeyForOrg
  }, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.action.getApiKeyForOrg()
    }
  }),
  withHandlers({
    onInstallChange: props => ({value}) => {
      props.action.setInstallOption(value)
    },
    onHelpWidgetClick: props => (value) => {
      window.drift.api.startInteraction({interactionId: value})
    }
  })
)(InstallChoice)


// WEBPACK FOOTER //
// ./src/layouts/InstallChoice/index.js